import { Head, Link } from "@inertiajs/react";
import { SANDBOX, sandboxedDocument } from "@/components/events/sandboxedHtml";
import type { SatelliteEvent } from "@/interfaces/satellite_event";
import type { Submission } from "@/interfaces/submission";

// Somebody's website, at its own address, hosted here because they had
// nowhere else to put it.
//
// Deliberately not wrapped in the app shell: this is their page and it gets
// the whole screen. The one strip of ours along the top is what keeps it from
// reading as a Boba Bash page - it says whose this is and where it came from,
// so nothing served from our domain can quietly pass itself off as us.
export default function BuiltSite({
  submission,
  event,
  html,
  css,
}: {
  submission: Submission;
  event: SatelliteEvent | null;
  html: string;
  css: string | null;
}) {
  return (
    <>
      <Head title={`${submission.title} by ${submission.author}`} />

      <div className="bg-bg flex h-dvh flex-col">
        <header className="border-line bg-surface flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b-2 px-4 py-2">
          <span className="font-display text-body text-ink font-bold">
            {submission.title}
          </span>
          <span className="text-caption text-ink-soft">
            by {submission.author}
          </span>
          <span className="text-caption text-ink-soft ml-auto">
            built at{" "}
            {event ? (
              <Link
                href={`/events/${event.slug ?? event.id}/submissions`}
                className="text-link underline"
              >
                {event.name}
              </Link>
            ) : (
              "Boba Bash"
            )}
          </span>
        </header>

        <iframe
          title={`${submission.title}, a website by ${submission.author}`}
          srcDoc={sandboxedDocument(html, css)}
          sandbox={SANDBOX}
          referrerPolicy="no-referrer"
          className="min-h-0 w-full flex-1 border-0 bg-white"
        />
      </div>
    </>
  );
}
